var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-pager" },
    [
      _c(
        "yxt-pagination",
        _vm._b(
          {
            attrs: {
              disabled: _vm.isDisabled,
              "current-page": _vm.currentPage,
              "page-sizes": _vm.pageSizes || [5, 10, 20, 30, 50, 100],
              "page-size": _vm.pager.pageSize,
              layout: _vm.layout || "total, prev, pager, next, sizes, jumper",
              total: _vm.pager.total,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          },
          "yxt-pagination",
          _vm.pageOption,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }